import { Markdown } from "../components/Markdown"
import { UmbrellaTemplate } from "../templates/UmbrellaTemplate"

export function FloridaPage() {
  return (
    <UmbrellaTemplate title="Florida Reception - Blake & Christie">
      <Markdown path="florida.md" />
    </UmbrellaTemplate>
  )
}
